var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramArtTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 28,
    viewBox: "0 0 155 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_44472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.985 7.82287L22.3188 24.5056H5.6511L13.985 7.82287ZM13.985 0L0 28H27.9699L13.985 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.985 14.0371L9.98712 22.0178H17.9753L13.985 14.0371Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_518_44472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5283 1.6084H55.3581V26.3848H59.5283V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8938 1.6084H66.7236V26.3848H70.8938V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5497 11.2157L56.772 15.2344L58.1187 19.1812L69.8964 15.1625L68.5497 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6186 1.6416H35.9699V5.81181H50.6186V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3827 3.72656H41.2125V26.3582H45.3827V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7879 28L73.7799 13.1461L82.9543 0L86.3699 2.38298L78.9099 13.0733L88.1373 25.5177L84.7879 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4626 11.0283H76.3482V15.1985H86.4626V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_518_44472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.865 26.7496L106.363 8.53367L100.214 26.7157L96.1373 25.3364L104.263 1.28397L106.064 1.27038L108.333 1.25L116.922 25.3024L112.865 26.7496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.524 19.3008L106.536 16.3125L103.547 19.3008L106.536 22.2892L109.524 19.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.966 27.0352H120.659V0L136.979 9.03664L125.014 21.6268L124.966 21.5792V27.0352ZM124.966 7.30405V15.4234L130.021 10.1034L124.966 7.30405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.472 15.088L125.276 17.9766L134.334 27.9971L137.529 25.1086L128.472 15.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.991 1.16895H139.853V5.47664H154.991V1.16895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.576 3.32324H145.268V26.703H149.576V3.32324Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_44472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9699,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_518_44472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(35.9699)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_518_44472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.8537,
    height: 28,
    fill: "white",
    transform: "translate(96.1373)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramArtTab);
export default __webpack_public_path__ + "static/media/programArtTab.7780222b6fc575b70586cf679aeb4931.svg";
export { ForwardRef as ReactComponent };